import { render, staticRenderFns } from "./WSimpleTextArea.vue?vue&type=template&id=20c99a77&"
import script from "./WSimpleTextArea.vue?vue&type=script&lang=js&"
export * from "./WSimpleTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports